// extracted by mini-css-extract-plugin
export default {"switchLabel":"switch_switchLabel__PtRCM","switchInput":"switch_switchInput__cHVNg"};